import React, { Component } from 'react';
import { ApiData } from "./config";
import { handleCallApi } from './calls';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, TablePagination, Chip
} from '@mui/material';
import LoadingSpinner from './_layout/spinner';

class Leads extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leads: [],
            count: 0,
            loading: false,
            page: 0,
            rowsPerPage: 50,
            deleteId: null,
            openDeleteConfirm: false,
        };
    }

    async componentDidMount() {
        await this.fetchLeads(0, this.state.rowsPerPage);
    }

    fetchLeads = async (skip, take) => {
        this.setState({ loading: true });
        try {
            const apiURL = `${ApiData.baseURL}/leads?skip=${skip}&take=${take}`;
            const response = await handleCallApi('GET', apiURL, null, '', '');
            if (response) {
                this.setState({ leads: response.results || [], count: response.count || 0 });
            }
        } catch (ex) {
            console.error(ex);
            toast.error('Failed to load leads');
        }
        this.setState({ loading: false });
    };

    handleChangePage = async (event, newPage) => {
        this.setState({ page: newPage });
        await this.fetchLeads(newPage * this.state.rowsPerPage, this.state.rowsPerPage);
    };

    handleChangeRowsPerPage = async (event) => {
        const rowsPerPage = parseInt(event.target.value, 10);
        this.setState({ rowsPerPage, page: 0 });
        await this.fetchLeads(0, rowsPerPage);
    };

    handleExportXls = () => {
        const token = localStorage.getItem('token');
        const url = `${ApiData.baseURL}/leads/export/xls`;
        fetch(url, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => res.blob())
            .then(blob => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'leads.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            })
            .catch(() => toast.error('Failed to export XLS'));
    };

    handleDeleteClick = (id) => {
        this.setState({ deleteId: id, openDeleteConfirm: true });
    };

    handleDeleteConfirm = async () => {
        const { deleteId, page, rowsPerPage } = this.state;
        this.setState({ openDeleteConfirm: false, loading: true });
        try {
            await handleCallApi('DELETE', `${ApiData.baseURL}/leads/${deleteId}`, null, '', '');
            toast.success('Lead deleted');
            await this.fetchLeads(page * rowsPerPage, rowsPerPage);
        } catch (ex) {
            toast.error('Failed to delete lead');
        }
        this.setState({ loading: false, deleteId: null });
    };

    handleDeleteClose = () => {
        this.setState({ openDeleteConfirm: false, deleteId: null });
    };

    formatDate = (iso) => {
        if (!iso) return '';
        return new Date(iso).toLocaleString();
    };

    render() {
        const { leads, count, loading, page, rowsPerPage, openDeleteConfirm } = this.state;

        return (
            <>
                {loading && <LoadingSpinner />}

                <Dialog open={openDeleteConfirm} onClose={this.handleDeleteClose}>
                    <DialogTitle>Delete Lead</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this lead? This cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleDeleteClose}>Cancel</Button>
                        <Button onClick={this.handleDeleteConfirm} color="secondary">Delete</Button>
                    </DialogActions>
                </Dialog>

                <table cellPadding="10" className="viewdata">
                    <tbody>
                        <tr>
                            <td><h2>Leads</h2></td>
                            <td></td>
                            <td style={{ textAlign: 'right' }}>
                                <Button
                                    variant="contained"
                                    style={{ backgroundColor: '#15cc09', color: '#fff', fontSize: 12 }}
                                    onClick={this.handleExportXls}
                                >
                                    Export XLS
                                </Button>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="3">
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>ID</strong></TableCell>
                                                <TableCell><strong>Type</strong></TableCell>
                                                <TableCell><strong>Full Name</strong></TableCell>
                                                <TableCell><strong>Email</strong></TableCell>
                                                <TableCell><strong>Phone</strong></TableCell>
                                                <TableCell><strong>Marketing</strong></TableCell>
                                                <TableCell><strong>Country</strong></TableCell>
                                                <TableCell><strong>Trip Name</strong></TableCell>
                                                <TableCell><strong>Trip Date</strong></TableCell>
                                                <TableCell><strong>Passengers</strong></TableCell>
                                                <TableCell><strong>Created At</strong></TableCell>
                                                <TableCell><strong>Actions</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {leads.length === 0 && !loading && (
                                                <TableRow>
                                                    <TableCell colSpan={12} style={{ textAlign: 'center', color: '#999' }}>
                                                        No leads found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {leads.map((lead) => (
                                                <TableRow key={lead.id} hover>
                                                    <TableCell>{lead.id}</TableCell>
                                                    <TableCell>
                                                        <Chip
                                                            label={lead.type === 'TRIP_INQUIRY' ? 'Trip Inquiry' : 'Travel Booking'}
                                                            size="small"
                                                            style={{
                                                                backgroundColor: lead.type === 'TRIP_INQUIRY' ? '#e3f2fd' : '#fce4ec',
                                                                fontSize: 11,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{lead.fullName}</TableCell>
                                                    <TableCell>{lead.email}</TableCell>
                                                    <TableCell>{lead.phone || '—'}</TableCell>
                                                    <TableCell>{lead.receiveMarketingUpdates ? '✓' : '—'}</TableCell>
                                                    <TableCell>{lead.metadata?.country || '—'}</TableCell>
                                                    <TableCell>{lead.metadata?.trip_name || '—'}</TableCell>
                                                    <TableCell>{lead.metadata?.trip_date || '—'}</TableCell>
                                                    <TableCell>
                                                        {Array.isArray(lead.metadata?.passengers)
                                                            ? lead.metadata.passengers.length
                                                            : '—'}
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                                        {this.formatDate(lead.createdAt)}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={() => this.handleDeleteClick(lead.id)}
                                                            style={{ fontSize: 11 }}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    component="div"
                                    count={count}
                                    page={page}
                                    onPageChange={this.handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    rowsPerPageOptions={[25, 50, 100]}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ToastContainer position="top-right" autoClose={3000} />
            </>
        );
    }
}

export default Leads;
